export interface ErrorBannerProps {
  message: string;
}

/**
 * Bannière d'erreur explicite (jamais un échec silencieux), pour les actions
 * panier/commande. Porté à l'identique depuis
 * apps/web/components/cart/ErrorBanner.tsx (aucune dépendance Next.js dans
 * l'original).
 */
export function ErrorBanner({ message }: ErrorBannerProps) {
  return (
    <div role="alert" className="border border-red-300 bg-red-50 px-4 py-3 text-sm font-medium text-red-800">
      {message}
    </div>
  );
}
